// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"paragraph_paragraph__8XGm9","left":"paragraph_left__Bq12Q","right":"paragraph_right__9V1eo","center":"paragraph_center__GFTEM","justyfy":"paragraph_justyfy__KDUdH"};